module.exports = __webpack_public_path__ + "static/media/google_play.cd839006.png";